// re-usable import statement to lazy load a component
// https://router.vuejs.org/guide/advanced/lazy-loading.html
const loadAsync = (component) => () => import(`@/components/${component}.vue`);

export {
    loadAsync as default
};
